export const SET_CHECKLISTS = 'SET_CHECKLISTS'
export const ADD_CHECKLIST = 'ADD_CHECKLIST'
export const EDIT_CHECKLIST = 'EDIT_CHECKLIST'
export const EDIT_CHECKLIST_ITEM = 'EDIT_CHECKLIST_ITEM'
export const DELETE_CHECKLIST_ITEM = 'DELETE_CHECKLIST_ITEM'
export const ADD_CHECKLIST_ITEM = 'ADD_CHECKLIST_ITEM'
export const DELETE_CHECKLIST = 'DELETE_CHECKLIST'
